import React, { useState } from "react";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";

import SignIn from "../components/Sign/SignIn";
import SignUp from "../components/Sign/SignUp";

import {
  createStyles,
  Grid,
  Hidden,
  makeStyles,
  Theme,
} from "@material-ui/core";

import Loading from "../components/Loading/Loading";
import { selectCart } from "../Stores/redisCartSlice";
import agent from "../Services/agent";
import { history } from "..";
import Carousel2 from "../components/Design2/Carousel2/Carousel2";
import { RegisterType } from "../Models/order";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      "@media only screen and (min-width: 600px)": {
        height: 800,
      },

      "@media only screen and (min-width: 960px)": {
        height: 1120,
      },

      "@media only screen and (min-width: 1280px)": {
        height: 580,
      },

      "@media only screen and (min-width: 1920px)": {
        height: 757,
      },
    },
  })
);

interface IProps {
  match: any;
}

const Sign: React.FC<IProps> = ({ match }) => {
  const classes = useStyles();
  const backUrl = match.params.backUrl as string;
  const [loading, setLoading] = useState(false);
  const cartList = useSelector(selectCart);

  const SubmitOrder = async () => {
    setLoading(true);

    await agent.Order.create({
      cartId: cartList.userCart.id,
      orderType: RegisterType.Web,
    })
      .then((res) => {
        history.push(`/payment/${res}`);
        setLoading(false);
      })
      .catch((error) => {
        toast.error("something went wrong try again");
        setLoading(false);
      });
  };

  const handleSubmit = () => {
    if (backUrl === "order") SubmitOrder();
    else if (backUrl === "address") history.push("/address");
    else if (backUrl) history.push(`/${backUrl}`);
    else
      window.location.href =
        localStorage.getItem("pushPath") !== null
          ? (localStorage.getItem("pushPath") as string)
          : "/";
  };

  if (loading) return <Loading />;

  return (
    <Grid container justifyContent="center" className={classes.root}>
      <Hidden xsDown>
        <div
          style={{
            position: "absolute",
            width: "100%",
            filter: "brightness(0.5)",
          }}
        >
          <Carousel2 />
        </div>
      </Hidden>
      <SignIn handleSubmit={handleSubmit} />
      <SignUp handleSubmit={handleSubmit} />
    </Grid>
  );
};

export default Sign;
